

/**
 * Date Me — "Leave a Request" scroll fix
 * ----------------------------------------
 * Shopify sometimes renders section wrapper IDs with an extra template
 * prefix (e.g. "shopify-section-template--xyz__form" instead of the plain
 * "shopify-section-form" we linked to), which breaks a plain #anchor
 * link. This catches that click, finds the actual form section by a
 * looser id match, and scrolls to it manually.
 */
(function () {
  "use strict";

  document.addEventListener("click", function (e) {
    const link = e.target.closest('a[href="#shopify-section-form"]');
    if (!link) return;

    const exact = document.getElementById("shopify-section-form");
    const target =
      exact ||
      document.querySelector('[id$="__form"], [id$="-form"], [id*="section-form"]');

    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    // If nothing matches, let the browser's default anchor behavior try.
  });
})();
